import {useEffect,useState} from 'react';
import {api} from './AuthContext';
export default function useMemberProfile(user){
 const [result,setResult]=useState(null);const id=user?.user_id;
 useEffect(()=>{let active=true;setResult(null);if(!id)return;
  api.get('/auth/profile').then(r=>{if(r.data?.user_id!==id)throw new Error('PROFILE_IDENTITY_MISMATCH');if(active)setResult({id,data:r.data});})
   .catch(()=>{if(active)setResult({id,error:true});});return()=>{active=false;};
 },[id]);
 return result?.id===id?result:null;
}
